import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as e, isNone as t } from "../../../../../core/maybe.js";
import { VTL_TEXTURE_BINDING_UNIT_SPRITES as i } from "../definitions.js";
import { WGLDrawPhase as n } from "../enums.js";
import { u32to4Xu8 as a } from "../number.js";
import r from "./WGLBrush.js";

var o = /*#__PURE__*/function (_r) {
  _inherits(o, _r);

  var _super = _createSuper(o);

  function o() {
    var _this;

    _classCallCheck(this, o);

    _this = _super.apply(this, arguments), _this._programOptions = {
      id: !1,
      pattern: !1,
      sdf: !1
    };
    return _this;
  }

  _createClass(o, [{
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "drawMany",
    value: function drawMany(r, _o) {
      var s = r.context,
          l = r.displayLevel,
          f = r.state,
          m = r.drawPhase,
          u = r.painter,
          c = r.pixelRatio,
          d = r.spriteMosaic,
          p = r.styleLayerUID;
      if (!_o.some(function (e) {
        var t, i;
        return null != (t = null == (i = e.layerData.get(p)) ? void 0 : i.lineIndexCount) && t;
      })) return;

      var g = r.styleLayer,
          y = g.lineMaterial,
          M = u.vectorTilesMaterialManager,
          v = g.getPaintValue("line-translate", l),
          _ = g.getPaintValue("line-translate-anchor", l),
          U = g.getPaintProperty("line-pattern"),
          x = void 0 !== U,
          P = x && U.isDataDriven;

      var E, D;

      if (x && !P) {
        var _e = U.getValue(l);

        E = d.getMosaicItemPosition(_e);
      }

      var V = !1;

      if (!x) {
        var _e2 = g.getPaintProperty("line-dasharray");

        if (D = void 0 !== _e2, V = D && _e2.isDataDriven, D && !V) {
          var _t = _e2.getValue(l),
              _i = g.getDashKey(_t, g.getLayoutValue("line-cap", l));

          E = d.getMosaicItemPosition(_i);
        }
      }

      var h = 1 / c,
          I = m === n.HITTEST,
          S = this._programOptions;
      S.id = I, S.pattern = x, S.sdf = D;
      var T = M.getMaterialProgram(s, y, S);

      if (s.useProgram(T), T.setUniformMatrix3fv("u_displayViewMat3", f.displayViewMat3), T.setUniformMatrix3fv("u_displayMat3", 1 === _ ? f.displayMat3 : f.displayViewMat3), T.setUniform2fv("u_lineTranslation", v), T.setUniform1f("u_depth", g.z), T.setUniform1f("u_antialiasing", h), I) {
        var _e3 = a(p + 1);

        T.setUniform4fv("u_id", _e3);
      }

      if (E && e(E)) {
        var _E = E,
            _t2 = _E.page,
            _n = d.getPageSize(_t2);

        e(_n) && (d.bind(s, 9729, _t2, i), T.setUniform2fv("u_mosaicSize", _n), T.setUniform1i("u_texture", i));
      }

      var w = -1;

      var _iterator = _createForOfIteratorHelper(_o),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _n2 = _step.value;
          if (!_n2.layerData.has(p)) continue;
          _n2.key.level !== w && (w = _n2.key.level, y.setDataUniforms(T, l, g, w, d));

          var _a = Math.pow(2, l - w) / c;

          T.setUniform1f("u_zoomFactor", _a);

          var _r2 = _n2.layerData.get(p);

          if (!_r2.lineIndexCount) continue;

          _r2.prepareForRendering(s);

          var _o3 = _r2.lineVertexArrayObject;

          if (!t(_o3)) {
            if (s.bindVAO(_o3), T.setUniformMatrix3fv("u_dvsMat3", _n2.transforms.dvs), s.setStencilFunction(514, _n2.stencilRef, 255), P || V) {
              var _t3 = _r2.patternMap;
              if (!_t3) continue;

              var _iterator2 = _createForOfIteratorHelper(_t3),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _step2$value = _slicedToArray(_step2.value, 2),
                      _n3 = _step2$value[0],
                      _a2 = _step2$value[1];

                  var _t4 = d.getPageSize(_n3);

                  e(_t4) && (d.bind(s, 9729, _n3, i), T.setUniform2fv("u_mosaicSize", _t4), T.setUniform1i("u_texture", i), s.drawElements(4, _a2[1], 5125, Uint32Array.BYTES_PER_ELEMENT * _a2[0]));
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } else s.drawElements(4, _r2.lineIndexCount, 5125, Uint32Array.BYTES_PER_ELEMENT * _r2.lineIndexStart);

            _n2.triangleCount += _r2.lineIndexCount / 3;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return o;
}(r);

export { o as WGLBrushVTLLine };